import { applyAuth0Theme } from "@/utils/theme/themeEngine";

import MfaPushEnrollmentQRForm from "./components/MfaPushEnrollmentQRForm";
import { useMfaPushEnrollmentQRManager } from "./hooks/useMfaPushEnrollmentQRManager";
import { AuthLayout } from "@/components/auth/AuthLayout";

function MfaPushEnrollmentQRScreen() {
    // Extracting attributes from hook made out of MfaPushEnrollmentQR instance of Auth0 React ACUL SDK
    const { texts, locales, mfaPushEnrollmentQR } =
        useMfaPushEnrollmentQRManager();

    applyAuth0Theme(mfaPushEnrollmentQR);
    return (
        <AuthLayout title={texts?.pageTitle || locales.page.title}>

            <MfaPushEnrollmentQRForm />

        </AuthLayout>
    );
}

export default MfaPushEnrollmentQRScreen;
